import type { RouteObject } from "react-router-dom";
import NotFound from "../pages/NotFound";
import Home from "../pages/home/page";
import Deratisation from "../pages/deratisation/page";
import RavetsCafards from "../pages/ravets-cafards/page";
import Termites from "../pages/termites/page";
import Scolopendres from "../pages/scolopendres/page";
import Desinsectisation from "../pages/desinsectisation/page";
import PunaisesDeLit from "../pages/punaises-de-lit/page";
import Demoustication from "../pages/demoustication/page";
import Tarifs from "../pages/tarifs/page";
import Soumission from "../pages/soumission/page";
import Merci from "../pages/merci/page";
import MentionsLegales from "../pages/mentions-legales/page";
import Blog from "../pages/blogue/page";
import ArticleRavets from "../pages/blogue/se-debarrasser-des-ravets/page";
import ArticleScolopendre from "../pages/blogue/morsure-scolopendre-que-faire/page";
import ArticleRat from "../pages/blogue/rat-dans-la-maison-que-faire/page";
import ArticleLeptospirose from "../pages/blogue/leptospirose-guadeloupe/page";
import ArticlePage from "../pages/blogue/article/page";

const routes: RouteObject[] = [
  { path: "/", element: <Home /> },
  { path: "/deratisation-guadeloupe", element: <Deratisation /> },
  { path: "/traitement-ravets-cafards-guadeloupe", element: <RavetsCafards /> },
  { path: "/traitement-termites-guadeloupe", element: <Termites /> },
  { path: "/punaises-de-lit-guadeloupe", element: <PunaisesDeLit /> },
  { path: "/scolopendres-guadeloupe", element: <Scolopendres /> },
  { path: "/demoustication-guadeloupe", element: <Demoustication /> },
  { path: "/desinsectisation-guadeloupe", element: <Desinsectisation /> },
  { path: "/tarifs", element: <Tarifs /> },
  { path: "/soumission", element: <Soumission /> },
  { path: "/devis", element: <Soumission /> },
  { path: "/merci", element: <Merci /> },
  { path: "/mentions-legales", element: <MentionsLegales /> },
  { path: "/blogue", element: <Blog /> },
  { path: "/blogue/se-debarrasser-des-ravets", element: <ArticleRavets /> },
  { path: "/blogue/morsure-scolopendre-que-faire", element: <ArticleScolopendre /> },
  { path: "/blogue/leptospirose-guadeloupe", element: <ArticleLeptospirose /> },
  { path: "/blogue/rat-dans-la-maison-que-faire", element: <ArticleRat /> },
  { path: "/blogue/comment-se-debarrasser-des-ravets", element: <ArticleRavets /> },
  { path: "/blogue/morsure-de-scolopendre-que-faire", element: <ArticleScolopendre /> },
  { path: "/blogue/:slug", element: <ArticlePage /> },
  { path: "*", element: <NotFound /> },
];

export default routes;